import { userAxios } from '../../index'

/**
 * Backoffice de Empresas. Permiso membership-company.manage.
 */

/** GET /api/companies */
const list = async () => {
  const response = await userAxios.get('companies')
  return response.data
}

/** GET /api/companies/{id} */
const detail = async companyId => {
  const response = await userAxios.get(`companies/${companyId}`)
  return response.data
}

/** POST /api/companies/{id}/employees */
const addEmployee = async (companyId, employee) => {
  const response = await userAxios.post(`companies/${companyId}/employees`, employee)
  return response.data
}

/** DELETE /api/companies/{id}/employees/{membership} */
const removeEmployee = async (companyId, membershipId) => {
  const response = await userAxios.delete(`companies/${companyId}/employees/${membershipId}`)
  return response.data
}

/** POST /api/companies/{id}/seats */
const updateSeats = async (companyId, quantity) => {
  const response = await userAxios.post(`companies/${companyId}/seats`, { quantity })
  return response.data
}

export default {
  list,
  detail,
  addEmployee,
  removeEmployee,
  updateSeats,
}
